export default __webpack_public_path__ + "static/media/Screenshot_1617151867.2c9bfe99.png";